

























































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import ValueAttribute from '../../classes/attributes/valueAttribute';
import TalentFieldObject from '../../classes/attributes/talentFieldObject';
import Character from '../../classes/character/character';

@Component
export default class CharacterDetailValueGroup extends Vue {
  @Prop()
  public groupTitle!: string;

  @Prop()
  public attributeList!: ValueAttribute[];

  @Prop()
  public attributeModifiers!: Record<string, string[]>;

  @Prop({ default: false })
  public talentFieldMode!: boolean;

  @Prop()
  public character!: Character;

  @Prop({ default: null })
  public color!: string | null;

  get style() {
    if (this.color === null) {
      return '';
    } else {
      return 'color: ' + this.color;
    }
  }

  private getModifiersOfAttribute(abbreviation: string) {
    if (typeof this.attributeModifiers[abbreviation] === 'undefined') {
      return [];
    } else {
      return this.attributeModifiers[abbreviation];
    }
  }

  private getTalentByField(abbreviation: string) {
    if (this.character === null) {
      return [];
    }
    return this.character.getTalentsByTalentField(abbreviation);
  }
}
